module.exports = __webpack_public_path__ + "9c269fd2f1c7ef73b682ae2f28a925d7.otf";